import LTR from "@brand-icons/global/social-whatsapp/social-whatsapp-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialWhatsappIcon = iconFactory("SocialWhatsappIcon", LTR);
